module.exports = __webpack_public_path__ + "static/media/ShopeePay.ff7504b2.png";